import { render } from "./Mybody.vue?vue&type=template&id=9a0ec584"
import script from "./Mybody.vue?vue&type=script&lang=js"
export * from "./Mybody.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__